import React from "react";
import "./quizStart.css";
import { useNavigate } from "react-router-dom";

export default function QuizStart() {
  let navigate = useNavigate();

  function navToCatalogue() {
    navigate("/catalogue");
  }

  function navToGuests() {
    navigate("/event-details");
  }

  return (
    <>
      <div className="start-page">
        <div onClick={() => navToCatalogue()} className="border-right">
          <img alt="" className="start-img" src={"./imgs/plug.png"} />
        </div>
        <div onClick={() => navToGuests()}>
          <img alt="" className="start-img" src={"./imgs/lightbulb.png"} />
        </div>
        <div onClick={() => navToCatalogue()} className="border-right">
          <h2 className="start-header">I know what I'm looking for</h2>
        </div>
        <div onClick={() => navToGuests()}>
          <h2 className="start-header">Help me find what I need</h2>
        </div>
        <div onClick={() => navToCatalogue()} className="border-right">
          <p>
            Show me the full catalogue of 
          </p>
          <p>
            Generators, Heaters and EV Chargers
          </p>
        </div>
        <div onClick={() => navToGuests()}>
          <p>Help me find the best most</p>
          <p> suitable equipment for my event </p>

        </div>
        <div onClick={() => navToCatalogue()} className="border-right"></div>
        <div onClick={() => navToGuests()}>2 mins</div>
        <div  onClick={() => navToCatalogue()} className="border-right click-to-start">Click to start</div>
        <div onClick={() => navToGuests()} className="click-to-start">Click to start</div>
      </div>
    </>
  );
}
